import { fetchProductsByType } from './utilities/fetch-products-by-type';
var ProductsDirectiveController = /** @class */ (function () {
    function ProductsDirectiveController($scope, $transclude, $element, $q) {
        this.$scope = $scope;
        this.$transclude = $transclude;
        this.$element = $element;
        this.$q = $q;
    }
    ProductsDirectiveController.prototype.$onInit = function () {
        var _this = this;
        if (this.$scope.pIds) {
            this.updateFromProducts();
        }
        this.$scope.$watch('pIds', function (newValue, oldValue) {
            if (newValue === oldValue) {
                return;
            }
            _this.updateFromProducts();
        });
    };
    ProductsDirectiveController.prototype.updateFromProducts = function () {
        var _this = this;
        if (this.$transcludeScope !== undefined) {
            this.$transcludeScope.$destroy();
            this.$transcludeScope = undefined;
            this.$element.empty();
        }
        this.$transclude(this.$scope, function ($clonedElement, $transcludeScope) {
            _this.$transcludeScope = $transcludeScope;
            if (!$clonedElement) {
                return;
            }
            _this.$element.append($clonedElement);
        });
        this.$scope.productIds = (this.$scope.pIds || '')
            .split(',')
            .map(Number)
            .filter(function (pId) { return !isNaN(pId); });
        this.$q.when(fetchProductsByType(this.$scope.productIds, this.$scope.pType))
            .then(function (products) {
            _this.$scope.products = products || [];
        });
    };
    ProductsDirectiveController.$inject = ['$scope', '$transclude', '$element', '$q'];
    return ProductsDirectiveController;
}());
export var ProductsDirective = [
    function () {
        return {
            controller: ProductsDirectiveController,
            restrict: 'E',
            scope: {
                pIds: '=',
                pType: '@',
            },
            transclude: true,
        };
    },
];
